import React, { useState, useRef, useEffect } from "react";
import {
  Stack,
  Button,
  TextField,
  Modal,
  Fade,
  Box,
  IconButton,
  Typography,
  Tooltip,
} from "@mui/material";
import pdfjsLib from "pdfjs-dist";
import { PDFDocument } from "pdf-lib";
import "react-image-crop/dist/ReactCrop.css";
import ReactCropper from "../../../Components/ReactCropper/ReactCropper";
import DragandDropFile from "../../../Components/DragAndDrop/DragandDrop";
import { dataURItoFile } from "../../../shared/commonfunctions";
import PreviewModalPopup from "../../../Components/Modals/PreviewModalPopup";
import PdfModal from "../../../Components/PdfModal/PdfModal";
import ClearIcon from "@mui/icons-material/Clear";
import { LoadingButton } from "@mui/lab";
import FormatStyles from "./SegmentUploadDocument.module.scss";
import UploadImage from "../../../Components/assets/Images/document-upload.svg";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SnackBar from "../../../Components/SnackBars/SnackBar";
import {
  DeleteSegmentDocumentAPICall,
  SegmentUploadDocumentsAPICall,
} from "../SegmentUpdateAPICalls";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { isMobile } from "react-device-detect";
import uploadwhiteicon from "../../../Components/assets/Images/uploadwhiteicon.svg";
import uploadblueicon from "../../../Components/assets/Images/uploadblueicon.svg";
import { confirmAlert } from "react-confirm-alert";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";

interface Props {
  acceptedFormats: any;
  previewImage: any;
  documentRef: string;
  documentID: any;
  displayOptions: any;
  stageDetailsData: any;
  name: string;
  purpose: string;
  pdfSize: number;
  imageSize: number;
}
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "90vH",
  bgcolor: "background.paper",
  p: 1,
  boxShadow: 24,
  borderRadius: "20px",
};

const FormatterCheckerSegment: React.FC<Props> = ({
  acceptedFormats,
  previewImage,
  documentRef,
  documentID,
  displayOptions,
  stageDetailsData,
  name,
  purpose,
  pdfSize,
  imageSize,
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showInput, setShowInput] = useState(false);
  const [preview, setPreview] = useState<string | null>(null);
  const [showModal, setshowModal] = useState(false);
  const [open, setOpen] = React.useState(true);
  const [showDragandDropModal, setshowDragandDropModal] = useState(false);
  const [image, setImage] = useState<any>();
  const [showPreviewModal, setshowPreviewModal] = useState(false);
  const [previewPDFFile, setpreviewPDFFile] = useState(false);
  const [imagedeleteLoading, setImagedeleteLoading] = useState(false);
  const [pdfdeleteLoading, setpdfdeleteLoading] = useState(false);
  const [uploadLoading, setuploadLoading] = useState(false);
  const [pdfUploadLoading, setpdfUploadLoading] = useState(false);
  const [previewLoading, setpreviewLoading] = useState(false);
  const [previewImageLoading, setpreviewImageLoading] = useState(false);
  const segmentRequestid: any = sessionStorage.getItem("segmentRequestid");
  const pdfPasswordRef = useRef("");
  let PasswordTyped: any = "";

  useEffect(() => {
    setImage(stageDetailsData);
    setSelectedFile(stageDetailsData);
  }, [stageDetailsData]);

  const handleUpload = () => {
    setshowDragandDropModal(true);
  };

  const handleFileChangeUpload = async (event: any) => {
    const file = event[0];
    setImage("");

    if (!file) {
      setSelectedFile(null);
      setErrorMessage("");
      return;
    }

    const fileType = file.type.split("/")[1];

    if (!acceptedFormats.includes(fileType)) {
      setSelectedFile(null);
      setErrorMessage(
        `Invalid file format. Only ${acceptedFormats.join(
          ", ",
        )} files are accepted.`,
      );
      return;
    }

    // if (file.size > UPLOADSIZELIMIT * 1024 * 1024) {
    // PDF File Size check
    if (fileType === "pdf" && file.size > pdfSize * 1024 * 1024) {
      setSelectedFile(null);
      setErrorMessage(`File size exceeds ${pdfSize}MB limit.`);
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      return;
    }
    // Image File Size check
    if (
      ["png", "jpg", "jpeg"].includes(fileType) &&
      file.size > imageSize * 1024 * 1024
    ) {
      setSelectedFile(null);
      setErrorMessage(`File size exceeds ${imageSize}MB limit.`);
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
      return;
    }

    if (fileType !== "pdf") {
      setOpen(true);
    }

    if (fileType === "pdf") {
      // setOpen(true);
      setpreviewPDFFile(true);
      setshowDragandDropModal(false);

      try {
        const bytes = await file.arrayBuffer();
        const pdfDoc = await PDFDocument.load(bytes, { updateMetadata: false });
        const pageCount = pdfDoc.getPageCount();
      } catch (e) {
        // window.alert("File is Password Protected, Please Enter Password");
        setShowInput(true);
      }
    }

    setSelectedFile(file);
    setshowModal(true);
    const fileUrl = URL.createObjectURL(file); // Create object URL for the file
    setPreview(fileUrl); // Set the preview with the file URL

    // console.log("Object URL", fileUrl);
    setErrorMessage("");
  };

  const handlePdfPreviewDone = () => {
    setpdfUploadLoading(true);
    previewImage(selectedFile);
    setshowModal(false);
    // console.log("documentRef", documentRef);
    const formData = new FormData();
    const obj: any = {
      file: selectedFile,
      request_id: segmentRequestid,
      doc_type_ref: purpose,
      file_password: pdfPasswordRef.current,
      doc_type_purpose: "income_proof",
    };

    formData.append("request_id", obj.request_id);
    formData.append("file", obj.file);
    formData.append("doc_type_ref", obj.doc_type_ref);
    formData.append("file_password", obj.file_password);
    formData.append("doc_type_purpose", obj.doc_type_purpose);
    setpreviewLoading(true);
    SegmentUploadDocumentsAPICall(formData)
      .then((response: any) => {
        const responseData = response.data;
        // console.log("response", response);

        setpdfUploadLoading(false);
        setShowInput(false);

        documentID(responseData.message);
        setpreviewLoading(false);

        if (displayOptions) displayOptions(false);
      })
      .catch((error: any) => {
        previewImage("");
        setshowModal(false);
        setShowInput(false);
        setSelectedFile(null);
        setpreviewPDFFile(false);

        // setErrorMessage("Error Uploading")
        setpdfUploadLoading(false);
        setpreviewLoading(false);

        setErrorMessage(
          error.message.includes("Network")
            ? "Error Uploading, Please try again"
            : error.response.data.message,
        );

        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
      });

    setOpen(false);
  };

  const handleCloseModal = () => setshowDragandDropModal(false);

  const handleCallBack = (data: any) => {
    setshowModal(false);
    if (data === "close") {
      // setTimeout(() => {
      setImage("close");
      // }, 3000);
    } else {
      previewImage(data.getCroppedCanvas().toDataURL());
      setImage(data.getCroppedCanvas().toDataURL());

      setSelectedFile(data.getCroppedCanvas().toDataURL());
      const ImageData = data;
      const formData = new FormData();

      if (ImageData !== "undefined") {
        const canvas = ImageData.getCroppedCanvas({
          maxWidth: 1000,
          maxHeight: 1000,
        });
        const dataURL = canvas.toDataURL();
        const file = dataURItoFile(dataURL, "cropped_image.png");
        //  console.log("documentRef:", documentRef);

        const obj: any = {
          file: selectedFile,
          request_id: segmentRequestid,
          doc_type_ref: purpose,
          file_password: "12345",
          doc_type_purpose: "income_proof",
        };

        formData.append("request_id", obj.request_id);
        formData.append("file", obj.file);
        formData.append("doc_type_ref", obj.doc_type_ref);
        formData.append("file_password", obj.file_password);
        formData.append("doc_type_purpose", obj.doc_type_purpose);
        // console.log("hello");
        setpreviewImageLoading(true);
        SegmentUploadDocumentsAPICall(formData)
          .then((response: any) => {
            const responseData = response.data;
            //  console.log("responseDataImage", responseData.message);
            setImage(responseData.data.url);
            setSelectedFile(responseData.data.url);

            documentID(responseData.message);

            setpreviewImageLoading(false);
            if (displayOptions) displayOptions(false);

            // setshowModal(false)
          })
          .catch((error: any) => {
            // console.log("error", error)
            setpreviewImageLoading(false);
            setSelectedFile(null);
            setErrorMessage(
              error.message.includes("Network")
                ? "Error Uploading, Please try again"
                : error.response.data.message,
            );

            setTimeout(() => {
              setErrorMessage("");
            }, 5000);
          });
      }
    }
  };
  const handlePreviewClick = () => {
    setshowPreviewModal(true);
  };
  const handleClosePreview = () => {
    setshowPreviewModal(false);
  };

  useEffect(() => {
    setshowDragandDropModal(false);
    if (image && image) {
      setOpen(false);
      if (image === "close") {
        setshowDragandDropModal(false);
      }
    } else {
      setOpen(true);
    }
  }, [image]);

  const handlePreviewPDFClick = () => {
    setshowPreviewModal(true);
  };

  const handledeleteImageClick = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="confitmalertUI">
            <DeleteOutlineRoundedIcon />
            <p>Are you sure, client will be permanently deleted</p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}
            >
              <button
                onClick={() => {
                  onClose();
                }}
                className="confitmbutton"
              >
                No
              </button>
              <button
                onClick={() => {
                  let obj: any = {
                    request_id: segmentRequestid,
                    document_purpose: "income_proof",
                  };
                  onClose();
                  setImagedeleteLoading(true);
                  DeleteSegmentDocumentAPICall(obj)
                    .then((response: any) => {
                      const responseData = response.data;
                      documentID("");

                      setSelectedFile(null);
                      setImagedeleteLoading(false);
                      if (displayOptions) {
                        displayOptions(true);
                      }
                    })
                    .catch((error: any) => {
                      setImagedeleteLoading(false);
                    });
                }}
                className="confitmbutton"
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handledeleteClick = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="confitmalertUI">
            <DeleteOutlineRoundedIcon />
            <p>Are you sure, client will be permanently deleted</p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
              }}
            >
              <button
                onClick={() => {
                  onClose();
                }}
                className="confitmbutton"
              >
                No
              </button>
              <button
                onClick={() => {
                  let obj: any = {
                    request_id: segmentRequestid,
                    document_purpose: "income_proof",
                  };
                  onClose();
                  setpdfdeleteLoading(true);
                  DeleteSegmentDocumentAPICall(obj)
                    .then((response: any) => {
                      const responseData = response.data;

                      //console.log("responseData", response);
                      documentID("");
                      setSelectedFile(null);
                      setpreviewPDFFile(false);
                      setpdfdeleteLoading(false);

                      if (displayOptions) {
                        displayOptions(true);
                      }
                    })
                    .catch((error: any) => {
                      setpdfdeleteLoading(false);
                    });
                }}
                className="confitmbutton"
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };
  const handleClosePdf = () => {
    setshowModal(false);
    setShowInput(false);
    setSelectedFile(null);
    setpreviewPDFFile(false);
  };

  const selectedfileName =
    selectedFile && image !== "close" && selectedFile.name;

  return (
    <Stack alignItems={"flex-end"}>
      <SnackBar message={errorMessage} />

      <Stack direction={"row"}>
        {!previewPDFFile && (!image || image === "close" || !selectedFile) && (
          <LoadingButton
            variant="contained"
            component="label"
            sx={{
              display: "flex",
              flexDirection: { xs: "column-reverse", sm: "row" },
              height: { xs: "max-height", sm: "35px" },
              color: { xs: "#3263E5", sm: "white" },
              borderRadius: "20px",
              boxShadow: "none",
              fontSize: "12px",
              background: { xs: "white", sm: "#3263E5" },
              "&:hover": {
                background: { xs: "white", sm: "#3263E5" },
              },
            }}
            onClick={handleUpload}
            id="documentsUploadButton"
            loading={uploadLoading}
          >
            <span>Upload</span>{" "}
            <img
              src={isMobile ? uploadblueicon : uploadwhiteicon}
              width={"20px"}
            />
          </LoadingButton>
        )}

        {image && image !== "close" && selectedFile && (
          <>
            {!previewImageLoading ? (
              <>
                <Tooltip title="Preview">
                  <LoadingButton
                    style={{
                      marginLeft: "10px",
                      color: "#292D32",
                      height: "30px",
                      borderRadius: "20px",
                      minWidth: "30px",
                    }}
                    variant="text"
                    onClick={handlePreviewClick}
                    id="documentsPreviewButton"
                    loading={previewImageLoading}
                  >
                    <VisibilityOutlinedIcon />
                  </LoadingButton>
                </Tooltip>
                <LoadingButton
                  style={{
                    // marginLeft: "10px",
                    color: "red",
                    height: "30px",
                    borderRadius: "20px",
                    minWidth: "30px",
                  }}
                  variant="text"
                  onClick={handledeleteImageClick}
                  color="error"
                  type="submit"
                  id="documentsDeleteButton"
                  loading={imagedeleteLoading}
                >
                  <DeleteOutlineIcon />
                </LoadingButton>{" "}
              </>
            ) : (
              <LoadingButton
                variant="contained"
                component="label"
                startIcon={
                  <img
                    src={isMobile ? uploadblueicon : uploadwhiteicon}
                    width={"20px"}
                  />
                }
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column-reverse", sm: "row" },
                  height: { xs: "max-height", sm: "35px" },
                  color: { xs: "#3263E5", sm: "white" },
                  borderRadius: "20px",
                  boxShadow: "none",
                  fontSize: "12px",
                  background: { xs: "white", sm: "#3263E5" },
                  "&:hover": {
                    background: { xs: "white", sm: "#3263E5" },
                  },
                }}
                onClick={handleUpload}
                id="documentsUploadButton"
                loading={true}
              >
                Upload
              </LoadingButton>
            )}
          </>
        )}
        {previewPDFFile && selectedFile && (
          <>
            {!previewLoading ? (
              <>
                <Tooltip title="Preview">
                  <LoadingButton
                    style={{
                      marginLeft: "10px",
                      color: "#292D32",
                      height: "30px",
                      borderRadius: "20px",
                      minWidth: "30px",
                    }}
                    loading={previewLoading}
                    variant="text"
                    onClick={handlePreviewPDFClick}
                    id="documentsPDFPreviewButton"
                  >
                    <VisibilityOutlinedIcon />
                  </LoadingButton>
                </Tooltip>
                <LoadingButton
                  style={{
                    // marginLeft: "10px",
                    color: "red",
                    height: "30px",
                    borderRadius: "20px",
                    minWidth: "30px",
                  }}
                  variant="text"
                  onClick={handledeleteClick}
                  color="error"
                  id="documentsPDFDeleteButton"
                  loading={pdfdeleteLoading}
                  type="submit"
                >
                  <DeleteOutlineIcon />
                </LoadingButton>
              </>
            ) : (
              <LoadingButton
                variant="contained"
                component="label"
                startIcon={
                  <img
                    src={isMobile ? uploadblueicon : uploadwhiteicon}
                    width={"20px"}
                  />
                }
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column-reverse", sm: "row" },
                  height: { xs: "max-height", sm: "35px" },
                  color: { xs: "#3263E5", sm: "white" },
                  borderRadius: "20px",
                  boxShadow: "none",
                  fontSize: "12px",
                  background: { xs: "white", sm: "#3263E5" },
                  "&:hover": {
                    background: { xs: "white", sm: "#3263E5" },
                  },
                }}
                onClick={handleUpload}
                id="documentsUploadButton"
                loading={true}
              >
                Upload
              </LoadingButton>
            )}
          </>
        )}
      </Stack>

      {showDragandDropModal && (
        <DragandDropFile
          showDragandDropModal={showDragandDropModal}
          handleCloseModal={handleCloseModal}
          handleFileChangeUpload={handleFileChangeUpload}
          acceptedFormats={acceptedFormats}
          errorMessage={errorMessage}
          selectedFile={selectedFile}
          showInput={showInput}
          image={image}
          pdfSize={pdfSize}
          imageSize={imageSize}
        />
      )}

      {showModal && (
        <Stack alignItems={"center"}>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={showModal}
            closeAfterTransition
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={showModal}>
              <Box sx={style}>
                {selectedFile && selectedFile.type === "application/pdf" && (
                  <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    margin={"0 30px"}
                  >
                    <Typography variant="h6">Preview</Typography>
                    <IconButton onClick={handleClosePdf}>
                      <ClearIcon />
                    </IconButton>
                  </Stack>
                )}

                <Stack
                  alignItems={"center"}
                  style={{
                    maxWidth: "100%",
                    maxHeight: "90%",
                    objectFit: "contain",
                  }}
                >
                  {selectedFile && selectedFile.type === "application/pdf" ? (
                    <>
                      <div className={FormatStyles.pdfDesktopPreview}>
                        <embed
                          src={URL.createObjectURL(selectedFile)}
                          width="950"
                          height="100%"
                          type="application/pdf"
                        />
                      </div>
                      <div className={FormatStyles.pdfMobilePreview}>
                        <PdfModal url={URL.createObjectURL(selectedFile)} />
                      </div>
                      <div
                        style={{
                          display: "flex",

                          paddingTop: "5px",
                        }}
                      >
                        {showInput ? (
                          <>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <TextField
                                style={{ marginRight: "10px" }}
                                id="outlined-basic"
                                label="Enter Password"
                                variant="outlined"
                                name="password"
                                size="small"
                                // value={pdfPassword}
                                onChange={(event) => {
                                  pdfPasswordRef.current = event.target.value;
                                }}
                                inputProps={{ maxLength: 15 }}
                              />
                              <p
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  margin: "5px",
                                }}
                              >
                                If the File is Password Protected, Please Enter
                                the Password
                              </p>
                            </div>
                          </>
                        ) : (
                          ""
                        )}
                        <LoadingButton
                          sx={{
                            width: "150px",
                            height: "40px",
                            marginTop: "10px",
                          }}
                          variant="contained"
                          onClick={handlePdfPreviewDone}
                          id="documentsDoneButton"
                          loading={pdfUploadLoading}
                          type="submit"
                          // disabled = {showInput === false && pdfPassword === ""}
                        >
                          Upload
                        </LoadingButton>
                      </div>
                    </>
                  ) : (
                    <ReactCropper
                      imageSource={preview}
                      callBackImage={handleCallBack}
                      // documentRef={documentRef}
                      // callBackDocumentId={handleCallBackDocument}
                    />
                  )}
                </Stack>
              </Box>
            </Fade>
          </Modal>
        </Stack>
      )}

      {showPreviewModal && (
        <Stack alignItems={"center"}>
          <PreviewModalPopup
            selectedFile={selectedFile}
            image={image}
            documentName={documentRef}
            handleClosePreview={handleClosePreview}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default FormatterCheckerSegment;
